import { useEffect, useMemo } from "react";
import { useQuery } from "@apollo/client";
import { GET_STANDS_CURSOR } from "graphql/query/stand-gql";
import {
    buildShelfAvailability,
    fetchRemainingStandPages,
    getStandsFromCursor,
    GRAPHIC_WAREHOUSE_CRAFT_FILTER,
    GRAPHIC_WAREHOUSE_ORDER_BY,
    GRAPHIC_WAREHOUSE_QUERY_PAGE_SIZE
} from "../helpers/shelf-availability-helper";

const EMPTY_VARIABLES = {};

const useShelfAvailability = ({
    variables = EMPTY_VARIABLES,
    skip = false,
    fetchPolicy = 'cache-and-network',
    nextFetchPolicy = 'cache-first'
} = {}) => {
    const queryVariables = useMemo(() => ({
        first: GRAPHIC_WAREHOUSE_QUERY_PAGE_SIZE,
        exclude_graphics_sent: true,
        whereCrafts: GRAPHIC_WAREHOUSE_CRAFT_FILTER,
        orderBy: GRAPHIC_WAREHOUSE_ORDER_BY,
        ...variables
    }), [ variables ]);

    const {
        data,
        loading,
        fetchMore,
        refetch
    } = useQuery(GET_STANDS_CURSOR, {
        skip,
        variables: queryVariables,
        fetchPolicy,
        nextFetchPolicy,
        notifyOnNetworkStatusChange: true
    });

    useEffect(() => {
        if (skip)
        {
            return;
        }

        fetchRemainingStandPages({
            data,
            loading,
            fetchMore
        });
    }, [ data, loading, fetchMore, skip ]);

    const stands = useMemo(() => getStandsFromCursor(data), [ data ]);
    const shelfAvailability = useMemo(() => buildShelfAvailability(stands), [ stands ]);

    return {
        data,
        loading,
        fetchMore,
        refetch,
        stands,
        shelfAvailability,
        ...shelfAvailability
    };
};

export default useShelfAvailability;
